import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    data: [],
    loading: false,
    error: {},
    totalItems: 0
};
const action = createSlice({
    name: 'action',
    initialState,
    reducers: {
        setActionData: (state, action) => {
            state.totalItems = action.payload.length;
            state.data = action.payload;
            return state;
        },
        setActionLoading: (state, action) => {
            state.loading = action.payload;
            return state;
        },
        setActionError: (state, action) => {
            state.error = action.payload;
            return state;
        }
    }
});
export const {setActionData,setActionLoading,setActionError} = action.actions;
export default action.reducer;
